import { render, staticRenderFns } from "./BlockMiniHeader.vue?vue&type=template&id=f642a1bc&"
import script from "./BlockMiniHeader.vue?vue&type=script&lang=js&"
export * from "./BlockMiniHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports